import OnboardingLayout from './index.vue'
import Login from './common/login'
import ForgetPassword from './common/forgetPassword'
import ResetPassword from './common/resetPassword'
import CreatePassword from './common/createPassword'
import Questionnaire from './common/questionnaire'
import QuestionnaireFinished from './common/questionnaireFinished'
import NestleRoutes from './nestle/route'
import MicroSite from './microSite'
import { ACCOUNT_TYPE } from '@/constant/common'

const indexPageName = 'onboardingIndexLayout'
const loginPageName = 'onboardingLogin'
const createPasswordPageName = 'onboardingCreatePassword'

export default {
  name: indexPageName,
  path: '/onboarding/:invitationId/index',
  component: OnboardingLayout,
  meta: {
    noAuth: true,
    noOnboardingPermissionCheck: true
  },
  children: [
    {
      name: loginPageName,
      path: '/onboarding/:invitationId/login',
      component: Login,
      meta: {
        titleI18nKey: 'onboarding.common.loginTitle',
        noOnboardingPermissionCheck: true
      }
    },
    {
      name: 'onboardingForgetPassword',
      path: '/onboarding/:invitationId/forget-password',
      redirect: (to) => {
        return { path: `/passport/${ACCOUNT_TYPE.CANDIDATE}/forget-password`, query: { onboarding_id: to.params.invitationId } }
      },
      component: ForgetPassword,
      meta: {
        titleI18nKey: 'onboarding.common.forgetPasswordTitle',
        noOnboardingPermissionCheck: true
      }
    },
    {
      name: 'onboardingResetPassword',
      path: '/onboarding/:invitationId/reset-password',
      redirect: (to) => {
        return { path: `/passport/${ACCOUNT_TYPE.CANDIDATE}/reset-password/${to.query.reset_code}`, query: { onboarding_id: to.params.invitationId } }
      },
      component: ResetPassword,
      meta: {
        titleI18nKey: 'onboarding.common.resetPasswordTitle',
        noOnboardingPermissionCheck: true
      }
    },
    {
      name: createPasswordPageName,
      path: '/onboarding/:invitationId/create-password',
      component: CreatePassword,
      meta: {
        titleI18nKey: 'onboarding.common.createPasswordTitle',
        noOnboardingPermissionCheck: true
      }
    },
    {
      name: 'onboardingCommonQuestionnaire',
      path: '/onboarding/:invitationId/questionnaire/:questionnaireId',
      component: Questionnaire,
      meta: {
        titleI18nKey: 'onboarding.common.questionnaireTitle'
      }
    },
    {
      name: 'onboardingCommonQuestionnaireFinished',
      path: '/onboarding/:invitationId/questionnaire-finished',
      component: QuestionnaireFinished,
      meta: {
        titleI18nKey: 'onboarding.common.questionnaireTitle'
      }
    },
    ...NestleRoutes,
    {
      name: 'onboardingSiteLayout',
      path: '/onboarding/:invitationId/site/:siteId/:pagePath*',
      component: MicroSite,
      meta: {
        title: '',
        noOnboardingPermissionCheck: true
      }
    }
  ]
}

export const needIndexRedirectRouteName = [indexPageName, loginPageName, createPasswordPageName]
